import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import React, { useTransition } from 'react';

import { ConditionalRender, Inline, Skeleton } from '@crossnokaye/ux-common';
import { Button } from '@crossnokaye/ux-common/ckds';

import { useSelectEquipment } from '@/features/equipment-browser/equipment-details/hooks/use-select-equipment';

import { JumpToEquipmentDropdown } from './jump-to-equipment-dropdown';

interface PrevNextButtonsProps {
  className?: string;
  isLoading?: boolean;
}

export const PrevNextButtons = ({
  isLoading,
  className,
}: PrevNextButtonsProps): React.ReactNode => {
  const [isPending, startTransition] = useTransition();
  const { selectPreviousAction, selectNextAction } = useSelectEquipment();

  const handlePrevious = () => {
    startTransition(async () => {
      await selectPreviousAction();
    });
  };

  const handleNext = () => {
    startTransition(async () => {
      await selectNextAction();
    });
  };

  return (
    <Inline gap="sm" className={className} wrap={false}>
      <ConditionalRender condition={!isLoading && !isPending} fallback={<Skeletons />}>
        <Button size={'md'} onClick={handlePrevious} disabled={isPending}>
          <ArrowLeftIcon className="w-5 h-5" />
        </Button>
        <JumpToEquipmentDropdown />
        <Button size={'md'} onClick={handleNext} disabled={isPending}>
          <ArrowRightIcon className="w-5 h-5" />
        </Button>
      </ConditionalRender>
    </Inline>
  );
};

const Skeletons = () => {
  return (
    <>
      <Skeleton className="w-10 h-9" />
      <Skeleton className="w-10 h-9" />
      <Skeleton className="w-10 h-9" />
    </>
  );
};
